/**
 * Utility functions for cloning and resetting sim script objects.
 *
 * @module utils/scripts
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * Creates a clone of the provided script object with updated properties.
 *
 * The cloned script will have specific properties reset to default values:
 * - `correctKeywords`: Reset to an empty array.
 * - `missedKeywords`: Reset to an empty array.
 * - `audio_url`: Reset to an empty string.
 * - `agent_recorded_audio`: Reset to an empty string.
 * - `recorded`: Reset to `false`.
 *
 * @param {Object} script - The script object to be cloned.
 * @returns {Object} A new script object with updated default properties.
 */
export const cloneScript = (script) => {
    let updatedScript = {...script};
    updatedScript.correctKeywords = [];
    updatedScript.missedKeywords = [];
    updatedScript.audio_url = '';
    updatedScript.agent_recorded_audio = '';
    updatedScript.recorded = false;
    return updatedScript;
};